
export const TitleType = [
  // Inicio
  { icon: "", text: "Inicio", path: "/inicio" },
  // Complejo
  { icon:"", text: "Complejo", path:"/complejo" },
  // Contratos
  { icon: "", text: "Listados de Contratos", path: "/contratos" },
  // Contratos Activos
  { icon: "", text: "Contratos Activos", path: "/contratos-activos" },
  // Indices
  { icon: "", text: "Valor de Índices Histórico", path: "/indices" },
  // Expensas
  { icon: "", text: "Expensas", path: "/expensas" },
  // Reporte de Compras
  { icon: "", text: "Reporte de Compras", path: "/reporte-compras" },
  // Reporte de Caja
  { icon: "", text: "Reporte de Caja", path: "/reporte-caja" },
  // Facturacion Punto Venta
  { icon: "", text: "Facturación por Punto de Venta", path: "/facturacion-punto-venta" },
  // Filtros
  { icon: "", text: "Disponibles", path: "/disponibles" },
  { icon: "", text: "Próximos a Vencer", path: "/proximo-vencer" },
  // Reservas
  { icon: "", text: "Reservas", path: "/reservas" },
  { icon: "", text: "Pedido de Reserva", path: "/reservas/pedido-reserva" },
  { icon: "", text: "Pedido de Reserva", path: "/reservas/reserva-pedido" },
  // Deudas
  { icon: "", text: "Deudas Por Inquilino", path: "/por-inquilino" },
  { icon: "", text: "Deudas Por Período", path: "/por-periodo" },
  { icon: "", text: "Deudas Por Complejo", path: "/por-complejo" },
  { icon: "", text: "Detalle de Deuda", path: "/detalles-deuda" },
  { icon: "", text: "Incobrables", path: "/incobrables" },
  // Dashboard
  { icon: "", text: "Dashboard", path: "/dashboard" },
  { icon: "", text: "Nueva Captación", path: "/dashboard/nueva-captacion" },
  { icon: "", text: "Editar Captación", path: "/dashboard/editar-captacion" },
  { icon: "", text: "Nueva Demanda", path: "/dashboard/nueva-demanda" },
  { icon: "", text: "Editar Demanda", path: "/dashboard/editar-demanda" },
  { icon: "", text: "Ofertas", path: "/dashboard/ofertas" },
  { icon: "", text: "Demandas", path: "/dashboard/demandas" },
  { icon: "", text: "Operaciones", path: "/dashboard/operaciones" },
  { icon: "", text: "Captaciones Pendientes", path: "/dashboard/captaciones-pendientes" },
  { icon: "", text: "Captaciones en Proceso", path: "/dashboard/captaciones-en-proceso" },
  { icon: "", text: "Captaciones Pendientes de Aprobación", path: "/dashboard/captaciones-pendientes-aprobacion" },
  { icon: "", text: "Propiedades Captadas", path: "/dashboard/propiedades-captadas" },
  { icon: "", text: "Perdido Captaciones", path: "/dashboard/perdido-captaciones" },
  { icon: "", text: "Oportunidades Demanda", path: "/dashboard/oportunidades-demanda" },
  { icon: "", text: "Demanda Captada", path: "/dashboard/demanda-captada" },
  { icon: "", text: "Perdido Consultas", path: "/dashboard/perdido-consultas" },
  { icon: "", text: "Operaciones en Proceso", path: "/dashboard/operaciones-en-proceso" },
  { icon: "", text: "Operaciones con Reserva", path: "/dashboard/operaciones-con-reserva" },
  { icon: "", text: "Operaciones Concretadas", path: "/dashboard/operaciones-concretadas" },
  { icon: "", text: "Operaciones Perdidas", path: "/dashboard/operaciones-perdidas" },
  // Valor de Alquilere
  { icon: "", text: "Valor de Alquiler", path: "/valor-alquileres"},
  { icon: "", text: "Valor de Alquiler", path: "/valor-alquileres/detalle/alquiler"},
  // Búsquedas
  { icon: "", text: "Búsquedas", path: "/busquedas"},
  // Cuotas
  { icon: "", text: "Cuotas", path: "/cuotas" },
  // Comprobantes Asociados
  { icon: "", text: "Comprobantes Asociados", path: "/cuotas/comprobantes-asociados"},
  // Laboratorio de Prototipos
  { icon: "", text: "Laboratorio de Prototipos", path: "/prototipos" },
  { icon: "", text: "Gestión de Comisiones", path: "/prototipos/comisiones" }
];